var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center w-full my-5"},[(_vm.showSeparator)?[_c('span',{staticClass:"border-t border-gray-400 w-4/5 h-1"}),_c('span',{staticClass:"font-bold uppercase flex-shrink-0 mx-5 text-xs"},[_vm._v(_vm._s(_vm.currentDate.format('MMM D')))]),_c('span',{staticClass:"border-t border-gray-400 w-4/5 h-1"})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }